import { render, staticRenderFns } from "./FrmWelcome.vue?vue&type=template&id=2f73362e&scoped=true"
import script from "./FrmWelcome.vue?vue&type=script&lang=js"
export * from "./FrmWelcome.vue?vue&type=script&lang=js"
import style0 from "./FrmWelcome.vue?vue&type=style&index=0&id=2f73362e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f73362e",
  null
  
)

export default component.exports